// ink-component
import React, { ReactNode } from 'react';

import getGlobalProps from '../../../../helpers/constants/global-props';
import HStack from '../../../HStack/HStack';

export interface HorizontalNavBeltProps {
  /** Modifier to highlight the active item */
  children?: ReactNode[];
}

const globalProps = getGlobalProps({});

/**
 * @purpose Preset of Box and HStack, use to add standard spacing between two React Nodes
 * @group HorizontalNav
 * @categories navigation
 */
const HorizontalNavBelt = ({ children }: HorizontalNavBeltProps) => {
  return (
    <HStack spacing="xsmall" align="distributed" {...globalProps}>
      {children}
    </HStack>
  );
};

HorizontalNavBelt.defaultProps = {
  children: undefined,
};

HorizontalNavBelt.displayName = 'HorizontalNav.Belt';

export default HorizontalNavBelt;
